import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home = () => {
  const { t } = useLanguage();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
        
      <Header />
      
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          height: { xs: '60vh', md: '70vh' },
          backgroundImage: 'url(/hero.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            zIndex: 1,
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2, paddingTop: '15vh' }}>
          <Box sx={{ textAlign: 'center', color: 'white' }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '2rem', md: '3rem', lg: '3.5rem' },
                fontWeight: 600,
                mb: 2,
                textShadow: '2px 2px 4px rgba(255, 255, 255, 0.5)',
              }}
            >
              {t('home.heroTitle')}
            </Typography>
            <Typography
              component="p"
              sx={{
                fontSize: { xs: '1.25rem', md: '1.50rem' },
                fontWeight: 300,
                mb: 4,
                textShadow: '1px 1px 2px rgba(255, 255, 255, 5.5)',
                color: 'inherit',
              }}
            >
              {t('home.heroSubtitle')}
            </Typography>
            <Button
              component={Link}
              to="/schedule"
              variant="contained"
              size="large"
              sx={{
                px: 4,
                py: 1.5,
                fontSize: { xs: '1rem', md: '1.1rem' },
                boxShadow: '0 8px 25px rgba(135, 206, 235, 0.4)',
              }}
            >
              {t('home.scheduleNow')}
            </Button>
          </Box>
        </Container>
      </Box>

      {/* About Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, md: 5 },
              maxWidth: '800px',
              backgroundColor: 'background.paper',
              borderRadius: 3,
              border: '1px solid rgba(135, 206, 235, 0.1)',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.8,
                color: 'text.primary',
                mb: 4,
                textAlign: 'justify',
              }}
            >
              {t('home.aboutText')}
            </Typography>
            
            <Box sx={{ textAlign: 'center' }}>
              <Button
                component={Link}
                to="/schedule"
                variant="contained"
                size="large"
                sx={{
                  px: 4,
                  py: 1.5,
                  fontSize: '1rem',
                }}
              >
                {t('home.scheduleNow')}
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
    
    <Footer />
      </Box>
  );
};

export default Home; 